export default __webpack_public_path__ + "static/media/dispute.fc21fadb.svg";